<div class="container py-4">
  <div class="col-md-12 mb-2 empl-tptxt">
    <h3>Onboarding Wizard</h3>
  </div>
  <p class="subtext">Complete each step to finish onboarding</p>

  <!-- Stepper -->
  <mat-horizontal-stepper #stepper [linear]="false" labelPosition="bottom">
    <!-- STEP 1: Company Details -->
    <mat-step>
      <ng-template matStepLabel>Company</ng-template>
      <form [formGroup]="companyForm">
        <app-company-step [formGroup]="companyForm" (saveAndNext)="onCompanySave(stepper)" (discard)="onDiscard()">
        </app-company-step>
      </form>
    </mat-step>

    <!-- STEP 2 — ENTITY -->
    <mat-step>
      <ng-template matStepLabel>Entity</ng-template>
      <form [formGroup]="entityForm">
        <app-company-entity-step
          [entities]="entities"
          (add)="addEntity()"
          (remove)="removeEntity($event)"
          (saveAndNext)="onEntitySave(stepper)"
          (discard)="discardStep()">
        </app-company-entity-step>
      </form>
    </mat-step>

    <!-- STEP 3 — SOP SETTINGS -->
    <mat-step>
      <form [formGroup]="sopForm">
        <ng-template matStepLabel>SOP Settings</ng-template>
        <app-sop-settings-step
          [form]="sopForm"
          [companyGroupId]="companyId"
          (saveAndNext)="onSopSave(stepper)"
          (discard)="discardStep()">
        </app-sop-settings-step>
      </form>
    </mat-step>

    <!-- STEP 4 — Employees -->
    <mat-step>
      <ng-template matStepLabel>Employee</ng-template>
      <app-employee-step
        [form]="empForm" (saveAndNext)="goToNextStep(stepper)" (discard)="discardStep()">
      </app-employee-step>
    </mat-step>

    <!-- STEP 5 — New Joiner Workflow -->
    <mat-step>
      <ng-template matStepLabel>New Joinee Workflow</ng-template>
      <app-main-screen-config style="width: 100%"></app-main-screen-config>
      <div class="d-flex justify-content-between mt-2">
        <!-- <button class="btn btn-outline-secondary" (click)="goBack(stepper)">Back</button>

        <div>
          <button class="btn btn-outline-secondary me-2" (click)="discard()">Discard</button>

          <button class="btn btn-primary" (click)="saveAndNext(stepper, 4)">Save & Next</button>
        </div> -->
      </div>
    </mat-step>

    <!-- STEP 6 — Others -->
    <mat-step>
      <ng-template matStepLabel>Others</ng-template>
      <app-other-company-settings></app-other-company-settings>
    </mat-step>
  </mat-horizontal-stepper>
</div>
